import { graphql } from "gql";

const EDIT_STARRED_ID_LIST_MUTATION = graphql(`
  mutation EditStarredIdList($starredIdList: [ID!]) {
    editMe(input: { starredIdList: $starredIdList }) {
      id
      starredIdList
    }
  }
`);

export default EDIT_STARRED_ID_LIST_MUTATION;
